module.exports = __webpack_public_path__ + "r-v3/img/stopCircle.c40779f3.svg";